import { render, staticRenderFns } from "./OrgChartTree.vue?vue&type=template&id=c3456dbe&scoped=true"
import script from "./OrgChartTree.ts?vue&type=script&lang=ts&external"
export * from "./OrgChartTree.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3456dbe",
  null
  
)

export default component.exports